module.exports = __webpack_public_path__ + "img/qr_app.1e6c3f57.png";